import React from 'react';
import { TextEditCell } from './TextEditCell';
import { parseAndShortenFloat } from '../../helperFunctions/helperFunctions';
import { CheckboxEditCell } from './CheckboxEditCell';
import { WarningCell } from './WarningCell';

export const latLonCell = (row, field, value, errors, editing) => {
  if (editing) {
    return (<TextEditCell errors={errors} name={`items[${row.get('id')}].${field}`} />);
  }
  return (<div>{parseAndShortenFloat(value)}</div>);
};

export const textCell = (row, field, value, errors, editing, parameters) => {
  let warning = false;
  let info = false;
  if (parameters) {
    if (parameters.warning) {
      warning = !!parameters.warning;
    }
    if (parameters.info) {
      info = !!parameters.info;
    }
  }
  if (editing) {
    return (
      <WarningCell warning={warning} info={info}>
        <TextEditCell warning info errors={errors} name={`items[${row.get('id')}].${field}`} />
      </WarningCell>
    );
  }
  return (
    <WarningCell warning={warning} info={info}>
      <div>{value}</div>
    </WarningCell>
  );
};

export const checkboxCell = (row, field, value, errors, editing) => {
  if (editing) {
    return (<CheckboxEditCell errors={errors} name={`items[${row.get('id')}].${field}`} />);
  }
  return (<div>{value ? 'Y' : 'N'}</div>);
};
